import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import withLanguage from '../lang-select/withLanguage'
import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'
import { LISTING_PORTAL_SEARCH_MODAL } from '../../../constants/modalType'
import { changeListing } from '../../../actions/listing'

class ListingPortalContainer extends React.Component {
  static propTypes = {
    portals: PropTypes.array.isRequired,
  }

  state = {
    portals: _.sortBy(this.props.portals, ['listingSeq']),
  }

  componentDidMount() {
    // this.props.modalActions.showModal(LISTING_PORTAL_SEARCH_MODAL, {})
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.portals, prevProps.portals)) {
      this.setState({
        portals: _.sortBy(this.props.portals, ['listingSeq']),
      })
    }
  }

  onSortEnd = ({ oldIndex, newIndex, ...rest }) => {
    this.setState(
      {
        portals: arrayMove(this.state.portals, oldIndex, newIndex),
      },
      this.handleValueChange,
    )
  }

  handleValueChange = () => {
    if (this.props.onValueChange) {
      const portals = _.map(this.state.portals, (portal, index) => {
        return {
          ...portal,
          listingSeq: index + 1,
        }
      })
      console.log(' portals', this.state.portals)

      // this.props.actions.changeListing('portals', portals)
      this.props.onValueChange(portals)
    }
  }

  handleListingRemove = value => {
    this.setState(
      preState => ({
        portals: _.reject(preState.portals, { listingSeq: value.listingSeq }),
      }),
      this.handleValueChange,
    )
  }

  handleStatusChange = (status, listingSeq) => {
    this.setState(
      preState => ({
        portals: _.map(preState.portals, portal => {
          if (portal.listingSeq === listingSeq) {
            return {
              ...portal,
              status,
            }
          } else {
            return portal
          }
        }),
      }),
      () => {
        console.log(this.state.portals)
        this.props.onValueChange(this.state.portals)
      },
    )
  }

  render() {
    return (
      <div>
        <div
          className="button is-primary"
          onClick={() =>
            this.props.modalActions.showModal(LISTING_PORTAL_SEARCH_MODAL, {})
          }
        >
          Add Portal
        </div>
        <SortableList
          pressDelay={100}
          items={this.state.portals}
          onSortEnd={this.onSortEnd}
          onListingRemove={this.handleListingRemove}
          onStatusChange={this.handleStatusChange}
        />
      </div>
    )
  }
}

export default compose(
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators({ changeListing: changeListing }, dispatch),
    }),
  ),
  withReduxModal,
)(ListingPortalContainer)

const SortableItem = withLanguage(
  SortableElement(
    ({ value, language = 'th', onListingRemove, onStatusChange, seq }) => (
      <div
        className={classNames('columns is-mobile')}
        style={{ background: seq % 2 === 0 && '#eee' }}
      >
        <td className="column">{seq}</td>
        <td className="column">
          <Link to={`/${_.get(value, 'hostRef')}/info`}>
            {_.get(value, 'info.title.' + language) || '-'}
          </Link>
        </td>
        <td className="column">
          <div
            className={classNames('select', {
              'is-danger': value.status === 'DRAFT',
            })}
          >
            <select
              value={value.status}
              onChange={e => {
                onStatusChange(e.target.value, value.listingSeq)
              }}
            >
              <option value="DRAFT">Draft</option>
              <option value="RELEASE">Release</option>
            </select>
          </div>
        </td>
        <td className="has-text-right" className="column">
          <button
            className="button is-danger"
            onClick={() => onListingRemove(value)}
          >
            x
          </button>
        </td>
      </div>
    ),
  ),
)

const SortableList = SortableContainer(
  ({ items, onListingRemove, onStatusChange }) => {
    return (
      <div>
        <div className="columns is-mobile" style={{ margin: 0, marginTop: 8 }}>
          <div className="column has-text-weight-bold">Seq</div>
          <div className="column has-text-weight-bold">Title</div>
          <div className="column has-text-weight-bold">Status</div>
          <div className="column has-text-weight-bold">Actions</div>
        </div>
        <hr style={{ margin: 0, marginBottom: 8 }} />

        {items.map((value, index) => (
          <SortableItem
            key={`item-${index}`}
            index={index}
            seq={index + 1}
            value={value}
            onStatusChange={onStatusChange}
            onListingRemove={onListingRemove}
          />
        ))}
      </div>
    )
  },
)



// WEBPACK FOOTER //
// ./src/components/templates/listing-portal/ListingPortalContainer.js